/**
 * Filtro customizado de Modelo para coleção Capas
 * Filtra produtos baseado na variante "Modelo"
 */

(function() {
  'use strict';

  // Verificar se estamos na coleção Capas (mais flexível)
  const pathname = window.location.pathname.toLowerCase();
  const isCapasCollection = pathname.includes('/collections/capas') || 
                           pathname.includes('/collections/capas/') ||
                           (document.body && document.body.getAttribute('data-collection-handle') === 'capas');
  
  if (!isCapasCollection) {
    return;
  }

  // Função principal de filtro
  function filterProductsByModel(selectedModel) {
    const productGrid = document.getElementById('product-grid');
    if (!productGrid) {
      console.warn('filter-modelo.js: product-grid não encontrado');
      return;
    }

    const products = productGrid.querySelectorAll('.grid__item, li.grid__item, [data-modelos]');
    let visibleCount = 0;

    // Controlar tamanho do grid quando há filtro ativo - manter tamanho consistente
    // Quando há filtro, o grid não deve ajustar tamanho baseado na quantidade de produtos visíveis
    if (selectedModel !== '' && selectedModel) {
      // Com filtro ativo: remover todas as classes que ajustam tamanho baseado na quantidade
      const dynamicGridClasses = ['grid--1-col-tablet', 'grid--2-col-tablet', 'grid--3-col-tablet', 
                                  'grid--4-col-tablet', 'grid--1-col-desktop', 'grid--2-col-desktop'];
      dynamicGridClasses.forEach(cls => productGrid.classList.remove(cls));
      
      // Garantir que o grid use sempre o tamanho padrão da configuração (3 col tablet, 4 col desktop)
      // Isso mantém os produtos com tamanho consistente independente da quantidade filtrada
      if (!productGrid.classList.contains('grid--3-col-tablet')) {
        productGrid.classList.add('grid--3-col-tablet', 'grid--one-third-max');
      }
      if (!productGrid.classList.contains('grid--4-col-desktop')) {
        productGrid.classList.add('grid--4-col-desktop', 'grid--quarter-max');
      }
      
      // Adicionar classe para indicar que há filtro ativo (pode ser usada para CSS adicional)
      productGrid.classList.add('filter-modelo-active');
    } else {
      // Sem filtro: remover classe de filtro ativo e restaurar comportamento normal
      productGrid.classList.remove('filter-modelo-active');
    }

    products.forEach((productElement) => {
      // Buscar modelos através do data attribute
      const modelosData = productElement.getAttribute('data-modelos');
      
      if (selectedModel === '' || !selectedModel) {
        // Mostrar todos os produtos
        productElement.style.display = '';
        visibleCount++;
      } else {
        // Verificar se o produto tem o modelo selecionado
        let shouldShow = false;
        
        if (modelosData) {
          // Os modelos estão armazenados como string separada por vírgula
          const modelos = modelosData.split(',').map(m => m.trim().toLowerCase());
          const selectedModelLower = selectedModel.toLowerCase().trim();
          
          shouldShow = modelos.some(modelo => {
            // Comparação exata primeiro, depois parcial
            return modelo === selectedModelLower || 
                   modelo.includes(selectedModelLower) || 
                   selectedModelLower.includes(modelo);
          });
        }

        productElement.style.display = shouldShow ? '' : 'none';
        if (shouldShow) visibleCount++;
      }
    });

    // Controlar visibilidade da paginação baseado na quantidade de produtos visíveis
    const paginationContainers = document.querySelectorAll('.AjaxinatePagination, [data-pagination], .pagination-wrapper, nav.pagination, ul.pagination__list, .pagination');
    
    paginationContainers.forEach(pagination => {
      if (selectedModel === '' || !selectedModel) {
        // Sem filtro: mostrar paginação normalmente (o servidor já controla isso)
        pagination.style.display = '';
        pagination.style.visibility = '';
        pagination.style.opacity = '';
        pagination.classList.remove('filter-modelo-hidden');
        // Mostrar todos os links de paginação
        const paginationLinks = pagination.querySelectorAll('a, button');
        paginationLinks.forEach(link => {
          link.style.display = '';
          link.style.visibility = '';
        });
      } else {
        // Com filtro ativo: SEMPRE esconder paginação
        // Como o filtro é client-side, todos os produtos filtrados já estão na primeira página
        // Não há necessidade de paginação quando há filtro ativo
        pagination.style.display = 'none';
        pagination.style.visibility = 'hidden';
        pagination.classList.add('filter-modelo-hidden');
      }
    });

    // Atualizar contador de produtos
    setTimeout(() => {
      const countElements = document.querySelectorAll('#ProductCount span, #ProductCountDesktop span');
      countElements.forEach(el => {
        if (el) {
          const countText = visibleCount === 1 ? '1 produto' : `${visibleCount} produtos`;
          el.textContent = countText;
        }
      });
    }, 100);
  }

  // Inicializar filtros
  function initModelFilter() {
    console.log('filter-modelo.js: Inicializando filtro de modelo...');
    
    const desktopFilter = document.getElementById('FilterModelo');
    const mobileFilter = document.getElementById('FilterModelo-mobile');

    if (!desktopFilter && !mobileFilter) {
      console.warn('filter-modelo.js: Filtros de modelo não encontrados na página');
      return;
    }

    // Handler para mudança de filtro
    const handleFilterChange = (event) => {
      // Prevenir comportamento padrão e propagação
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      
      const selectedValue = event.target.value;
      const selectedModel = selectedValue ? selectedValue.toLowerCase().trim() : '';
      
      console.log('filter-modelo.js: Modelo selecionado:', selectedModel);
      
      // Atualizar URL sem recarregar página
      const url = new URL(window.location);
      if (selectedModel === '') {
        url.searchParams.delete('modelo');
      } else {
        url.searchParams.set('modelo', selectedValue);
      }
      window.history.pushState({}, '', url);

      // Filtrar produtos
      filterProductsByModel(selectedModel);

      // Sincronizar ambos os selects
      if (event.target.id === 'FilterModelo' && mobileFilter) {
        mobileFilter.value = selectedValue;
      } else if (event.target.id === 'FilterModelo-mobile' && desktopFilter) {
        desktopFilter.value = selectedValue;
      }
      
      return false;
    };

    if (desktopFilter) {
      console.log('filter-modelo.js: Filtro desktop encontrado');
      
      // Interceptar evento input ANTES que chegue ao form (capture phase)
      desktopFilter.addEventListener('input', (e) => {
        if (e.target.id === 'FilterModelo') {
          e.stopPropagation();
          e.stopImmediatePropagation();
          e.preventDefault();
        }
      }, true);
      
      desktopFilter.addEventListener('change', handleFilterChange, true);
      
      // Prevenir que qualquer evento do select dispare submit do form
      const formDesktop = desktopFilter.closest('form');
      if (formDesktop) {
        // Interceptar no form também
        formDesktop.addEventListener('input', (e) => {
          if (e.target && e.target.id === 'FilterModelo') {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }
        }, true);
        
        formDesktop.addEventListener('submit', (e) => {
          if (desktopFilter === document.activeElement || e.target.contains(desktopFilter)) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }
        }, true);
      }
      
      // Aplicar filtro inicial se houver na URL
      const urlParams = new URLSearchParams(window.location.search);
      const modeloParam = urlParams.get('modelo');
      if (modeloParam) {
        desktopFilter.value = modeloParam;
        filterProductsByModel(modeloParam.toLowerCase().trim());
      }
    }

    if (mobileFilter) {
      console.log('filter-modelo.js: Filtro mobile encontrado');
      
      // Interceptar evento input ANTES que chegue ao form (capture phase)
      mobileFilter.addEventListener('input', (e) => {
        if (e.target.id === 'FilterModelo-mobile') {
          e.stopPropagation();
          e.stopImmediatePropagation();
          e.preventDefault();
        }
      }, true);
      
      mobileFilter.addEventListener('change', handleFilterChange, true);
      
      // Prevenir que qualquer evento do select dispare submit do form
      const formMobile = mobileFilter.closest('form');
      if (formMobile) {
        // Interceptar no form também
        formMobile.addEventListener('input', (e) => {
          if (e.target && e.target.id === 'FilterModelo-mobile') {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }
        }, true);
        
        formMobile.addEventListener('submit', (e) => {
          if (mobileFilter === document.activeElement || e.target.contains(mobileFilter)) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }
        }, true);
      }
      
      // Aplicar filtro inicial se houver na URL
      const urlParams = new URLSearchParams(window.location.search);
      const modeloParam = urlParams.get('modelo');
      if (modeloParam) {
        mobileFilter.value = modeloParam;
        filterProductsByModel(modeloParam.toLowerCase().trim());
      }
    }
  }

  // Aguardar DOM estar pronto e também aguardar um pouco mais para garantir que tudo foi carregado
  function init() {
    setTimeout(() => {
      initModelFilter();
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-executar quando o conteúdo da página for atualizado via AJAX
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
  
  // Observer para mudanças no DOM (caso produtos sejam carregados via AJAX)
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver((mutations) => {
      const hasProductGrid = document.getElementById('product-grid');
      const hasFilter = document.getElementById('FilterModelo') || document.getElementById('FilterModelo-mobile');
      
      if (hasProductGrid && hasFilter) {
        initModelFilter();
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

})();

